import { Control, FormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextInput from './TextInput';
import validationUtils from '../../services/validationUtils';

interface NameProps {
  namePrefix?: string;
  control: Control;
  formState: FormState<any>;
  required?: boolean;
  requiredFieldMessage?: string;
  firstNameLabel?: string;
  lastNameLabel?: string;
  showMiddleName?: boolean;
}

export default function Name({
  namePrefix = '',
  control,
  formState,
  required = true,
  requiredFieldMessage,
  firstNameLabel,
  lastNameLabel,
  showMiddleName = false,
}: NameProps) {
  const { t } = useTranslation('common');

  const firstLabel: string = firstNameLabel || t('common.firstName');
  const lastLabel: string = lastNameLabel || t('common.lastName');
  const middleLabel = t('driver.middleName');

  return (
    <>
      <TextInput
        label={firstLabel}
        name={namePrefix + 'FirstName'}
        required={required}
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
          pattern: validationUtils.firstnameValidation(),
        }}
        inputProps={{ maxLength: 50 }}
      />
      {showMiddleName ? (
        <TextInput
          label={middleLabel}
          name={namePrefix + 'MiddleName'}
          required={false}
          control={control}
          errors={formState.errors}
          inputProps={{ maxLength: 50 }}
        />
      ) : null}
      <TextInput
        label={lastLabel}
        name={namePrefix + 'LastName'}
        required={required}
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
          pattern: validationUtils.lastnameValidation(),
        }}
        inputProps={{ maxLength: 50 }}
      />
    </>
  );
}
